import styled from 'styled-components'

export const Circle = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${({ color }) => (color ? color : '#D3D3D3')};
  margin-left: 8px;
`
